export default __webpack_public_path__ + "static/media/Squares_01.7811ae0c.png";